// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getPosts } from "./main-pages/posts/get-posts.action";
import { getGallery } from "./main-pages/galleries/get-gallery.action";
import { getHomeGallery } from "./main-pages/home/get-home-gallery.action";
import { logout } from "./global-common.slice";

// ############################################################

// Initial state
const initialState = {
	isOpen: false,
	mediaType: "any",
	searchSex: null,
	period: {
		startDate: {
			month: 0,
			year: 2015,
		},
		selectedDate: {
			day: null,
			month: null,
			year: null,
		},
		period: "latest",
		year: new Date().getFullYear(),
	},
	location: {
		cityId: "any",
		cityName: null,
		country: "all",
		countryName: null,
		distance: 50,
		regionId: "any",
		regionName: null,
		showError: false,
		url: null,
	},
};

// ############################################################

const updateSharedFiltersState = (state, action) => {
	const { filters, min_dates } = action.payload;
	state.searchSex = filters.searchSex;
	state.period = {
		...state.period,
		...filters.period,
		startDate: {
			...state.period.startDate,
			year: min_dates?.year || state.period.startDate.year,
			month: min_dates?.month || state.period.startDate.month,
		},
	};
	state.location = {
		...state.location,
		...filters.location,
	};
	state.mediaType = filters.mediaType || state.mediaType;
};

// ############################################################

// Slice
const sharedFiltersSlice = createSlice({
	name: "sharedFilters",
	initialState,
	reducers: {
		closeFilters: (state) => {
			state.isOpen = false;
		},
		toggleFilters: (state) => {
			state.isOpen = !state.isOpen;
		},
		setSearchSex: (state, action) => {
			state.searchSex = [...action.payload];
		},
		setLocation: (state, action) => {
			state.location = {
				...action.payload,
			};
		},
		resetSharedFilters: () => {
			return {
				...initialState,
			};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getPosts.pending, (state) => {
				state.isOpen = false;
			})
			.addCase(getPosts.fulfilled, updateSharedFiltersState)
			.addCase(getGallery.fulfilled, updateSharedFiltersState)
			.addCase(getHomeGallery.fulfilled, updateSharedFiltersState)
			// ** Clear Shared Filters after Logout
			.addCase(logout, () => {
				return initialState;
			});
	},
});

// ############################################################

export const {
	setSearchSex,
	resetSharedFilters,
	setLocation,
	openFilters,
	closeFilters,
	toggleFilters,
} = sharedFiltersSlice.actions;

export default sharedFiltersSlice.reducer;

// ############################################################
